import * as firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FB_API_KEY,
    authDomain: "ptm-pwa-118f6.firebaseapp.com",
    databaseURL: "https://ptm-pwa-118f6.firebaseio.com",
    projectId: "ptm-pwa-118f6",
    storageBucket: "ptm-pwa-118f6.appspot.com",
    messagingSenderId: "14713815642",
    appId: "1:14713815642:web:6ef3f3479fde1739d54e63"
  };
  const firebaseApp = firebase.initializeApp(firebaseConfig);

  export default firebaseApp.firestore()